import { render, staticRenderFns } from "./bargainPublicity.vue?vue&type=template&id=6c835b21"
import script from "./bargainPublicity.vue?vue&type=script&lang=js"
export * from "./bargainPublicity.vue?vue&type=script&lang=js"
import style0 from "./bargainPublicity.vue?vue&type=style&index=0&id=6c835b21&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports